module.exports = __webpack_public_path__ + "img/block_3_binder.3ce2001c.png";